// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__RBGgg","link":"NavBar_link__JeYxh"};